module.exports = __webpack_public_path__ + "img/LOTUS.58a7248.jpg";